window.first_question_filled = false;
window.second_question_filled = false;
window.user_link = new URLSearchParams(window.location.search).get('link');
if (window.user_link == null) {
    $('.loading-wrapper').hide();
    document.body.classList.remove("page-loader");
    var $mainWrapper = $('.questionnaire_form_main');
        $mainWrapper.find('.dm-form-wrapper').addClass('hide');
        $mainWrapper.find('.progress_bar').addClass('hide');
        var successHTML = `
        <div class="form-success-message">
            <p><b>The link appears to be expired or has already been submitted.</b></p>
            <a href="/" class="btn">Go to Home</a>
        </div>
        `;

        // Append success message
        $mainWrapper.append(successHTML);
}

function dehandleize(str) {
  return str
    .replace(/-/g, ' ')                
    .replace(/\b\w/g, c => c.toUpperCase());
}
function ensureHiddenField(handle, label) {
    if ($('.form-selected-answer [data-handle="' + handle + '"]').length === 0) {
        $('.form-selected-answer').append(
            '<input type="hidden" name="' + label + '" data-handle="' + handle + '" value="">'
        );
    }
}

function setHiddenField(handle, value) {
    $('.form-selected-answer [data-handle="' + handle + '"]').val(value);
}

async function getEntryByLink() {
    $('.loading-wrapper').show();
  // Cache DOM elements upfront (single query each)
  const $fullName     = $("#full-name");
  const $startingBmi  = $("#starting-bmi");
  const $startingWeight = $("#starting-weight");
  const $dobInputs    = $(".dob-block input");
  const $dobInputsWrapper    = $(".dob-block");

  // URL param extraction
  const link = new URLSearchParams(window.location.search).get('link');
  if (!link) {
    $('.loading-wrapper').hide();
    document.body.classList.remove("page-loader");
  }
  if (!link) return console.error('Link parameter not found in URL');
  try {
    const res = await fetch('https://bursthealthcare.com/api/get_entry_by_link', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `random_string=${encodeURIComponent(link)}`  // URLSearchParams object avoid — faster
    });

    if (!res.ok) throw new Error(`HTTP Error: ${res.status} ${res.statusText}`);

    const data = await res.json();
    if (data.status == 'true') {
        $('.loading-wrapper').hide();
        document.body.classList.remove("page-loader");
        const d = data.data;

        // Keys as constants (avoids repeated long string lookups)
        const name        = d['Discretion_is_at_the_heart_of_what_we_do_but_for_legal_reasons_the_name_on_your_prescription_must_be_your_full_legal_name__Please_provide_your_legal_name_as_per_your_official_government_ID_'];
        const dob         = d['Please_enter_your_date_of_birth__*'];
        const bmi         = d['What_is_your_BMI_(body_mass_index)?_*'];
        const startWeight = d['Please_enter_your_height_in_centimetres_and_weight_in_kilograms?_*'];

        // Batch DOM updates
        if (name) {
            $fullName.closest(".ans-block").addClass("hide");
            $fullName.val(name);
        }
        let getWeightNumber;
        let getHeightNumber;
        let setBmiValue;
        if (startWeight) {
            $startingWeight.closest(".ans-block").addClass("hide");
            getWeightNumber = startWeight.split('-')[1];
            if (getWeightNumber.includes("weight")) {
                getWeightNumber = getWeightNumber.replace("weight","").trim();
            }
            $startingWeight.val(Number(getWeightNumber));
            getHeightNumber = startWeight.split('-')[0];
            if (getHeightNumber.includes("height")) {
                getHeightNumber = getHeightNumber.replace("height","").trim();
            }
            if (getHeightNumber && getWeightNumber){
                const BMII = (Number(getWeightNumber) / Number(getHeightNumber) ** 2 ) * 10000;
                BMI = BMII.toFixed(2);
                $startingBmi.closest(".ans-block").addClass("hide");
                $startingBmi.val(BMI);
                setBmiValue = BMI;
            }
        }
        if (bmi) {
            $startingBmi.closest(".ans-block").addClass("hide");
            $startingBmi.val(bmi);
            setBmiValue = bmi;
        }
        
        if (dob) {
        $dobInputsWrapper.closest(".ans-block").addClass("hide");
        const parts = dob.split("/");
        $dobInputs.each(function(i) {
            if (parts[i]) $(this).val(parts[i]);
        });
        }
        // ── Track which questions are fully pre-filled ──
        if (name && dob) {
        window.first_question_filled = true;
        }
        if (setBmiValue && startWeight) {
        window.second_question_filled = true;
        }
        
        var dataToSave = {
            'starting-weight'    : getWeightNumber ? getWeightNumber : "",
            'starting-bmi'       : setBmiValue ? setBmiValue : "",
            'full-name'          : name ? name : "",
            'enter-your-date-of-birth'      : dob ? dob : ""
        };

        $.each(dataToSave, function (handle, val) {
            const normalText = dehandleize(handle);
            ensureHiddenField(handle, normalText);
            setHiddenField(handle, val);
        });
    } else {
        $('.loading-wrapper').hide();
        document.body.classList.remove("page-loader");
        var $mainWrapper = $('.questionnaire_form_main');
        $mainWrapper.find('.dm-form-wrapper').addClass('hide');
        $mainWrapper.find('.progress_bar').addClass('hide');
        var successHTML = `
        <div class="form-success-message">
            <p><b>The link appears to be expired or has already been submitted.</b></p>
            <a href="/" class="btn">Go to Home</a>
        </div>
        `;

        // Append success message
        $mainWrapper.append(successHTML);
    }

  } catch (err) {
    console.error('Fetch failed:', err);
  }
}

getEntryByLink();



// ── Cookie Utilities ──────────────────────────────────────────────────────────

function setCookie(name, value) {
    document.cookie = name + '=' + value + '; path=/';
}

function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf(key + '=') === 0) {
            return decodeURIComponent(cookie.substring(key.length + 1));
        }
    }
    return null;
}

function deleteCookie(key) {
    document.cookie = key + '=; expires=' + new Date(0).toUTCString() + '; path=/';
}

function handleChange(newValue) {
    setCookie('weekly-maintenance_lastQuestionafter', newValue);
}

function numberChange(lastNumber) {
    setCookie('weekly-maintenance_lastNumber', lastNumber);
}

function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
    var existingCookieValue = getCookie(key);
    var existingObject = existingCookieValue ? JSON.parse(existingCookieValue) : {};

    existingObject.items = existingObject.items || [];

    // Update existing key if already present, else push new
    var found = false;
    for (var i = 0; i < existingObject.items.length; i++) {
        var item = existingObject.items[i];
        for (var k in newValue) {
            if (item.hasOwnProperty(k)) {
                existingObject.items[i][k] = newValue[k];
                found = true;
            }
        }
    }
    if (!found) {
        existingObject.items.push(newValue);
    }

    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 10);

    document.cookie = key + '=' + encodeURIComponent(JSON.stringify(existingObject)) + '; expires=' + expirationDate.toUTCString() + '; path=/';

    handleChange(afterQuestion);
    numberChange(lastNumber);
}


// ── Hidden Field Append Utility ───────────────────────────────────────────────
// handle = data-handle value, label = human readable name attribute




// ── Shake Effect ──────────────────────────────────────────────────────────────

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function () {
        $selector.addClass('shake_animation');
        setTimeout(function () {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}


// ── Date Helpers ──────────────────────────────────────────────────────────────

function isValidDate(dd, mm, yyyy) {
    var d = parseInt(dd), m = parseInt(mm), y = parseInt(yyyy);
    if (isNaN(d) || isNaN(m) || isNaN(y)) return false;
    if (d < 1 || d > 31 || m < 1 || m > 12 || y < 1900 || y > 2100) return false;
    var date = new Date(y, m - 1, d);
    return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}

function pad(n) {
    return String(parseInt(n)).padStart(2, '0');
}


// ── Keyboard Handlers ─────────────────────────────────────────────────────────

$('.dm-data-validate').keypress(function (e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length > $limit) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-birthdata-validate').keypress(function (e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length > $limit) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function (e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function () {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();
    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});


// ── Question Label → Handle mapping ──────────────────────────────────────────

$('.dm-question').each(function () {
    var $question = $(this).html();
    var $que = $question.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    ensureHiddenField($que, $question);
});


// ── Single-select checkbox behaviour ─────────────────────────────────────────

$('.form_loop input[type=checkbox]').click(function () {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});


// ── First Question Start Button ───────────────────────────────────────────────

$('.first_questions_section .form_action_btn').click(function () {
    const $currentLoop = $(this).parents('.form_loop');
    // Figure out how many loops to skip (0, 1, or 2)
    let skipCount = 0;
    if (window.first_question_filled)  skipCount = 1;
    if (window.first_question_filled && window.second_question_filled) skipCount = 2;

    // Hide current intro loop
    $currentLoop.removeClass('d-block').addClass('d-none');

    // Find target loop by skipping 'skipCount' form_loops
    let $target = $currentLoop;
    for (let i = 0; i <= skipCount; i++) {
        $target = $target.next('.form_loop');
    }

    console.log(skipCount,skipCount > 0,"skipCountskipCountskipCount")
    if (skipCount > 0) {
        var getQuestion = $('[data-question="patient-identification"] .type_ans_field #full-name').val();
        if (getQuestion) {
            var userName = `
                <div class="user-message">
                    <h2>${getQuestion}</h2>
                </div>
            `;
            $target.find(".form_inner").before(userName);
        }
    }

    $target.addClass('d-block');
    $target.find('.number').html(1);

    // if (window.first_question_filled) {
    //     $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().next().addClass('d-block');
    //     $(this).parents('.form_loop').next().next().find('.number').html(1);
    // } else {
    //     $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    //     $(this).parents('.form_loop').next().find('.number').html(1);
    // }
    $('.progress_content').show();
    pushHistory(1);

    $('html, body').animate({ scrollTop: 0 }, 800);

    // Clear old session cookies
    deleteCookie('weekly-maintenance');
    deleteCookie('weekly-maintenance_lastQuestionafter');
    deleteCookie('weekly-maintenance_lastNumber');

    // Clear all hidden fields
    // $('.form-selected-answer input[type="hidden"]').each(function () {
    //     if ($(this).val()) {
            
    //     }
    //     $(this).val('');
    // });

    // Country default
    ensureHiddenField('which-country-do-you-live-in', 'Which country do you live in? *');
    setHiddenField('which-country-do-you-live-in', 'AU');
    ensureHiddenField('initial-indication', 'Initial Indication');
    setHiddenField('initial-indication', 'weight reduction management');
});


// ── Continue Button (Resume from cookie) ─────────────────────────────────────

$('.continue_btn_content .continue_action_btn').click(function () {
    var lastQuestion = getCookie('weekly-maintenance_lastQuestionafter');
    var lastNumber   = getCookie('weekly-maintenance_lastNumber');

    if (lastQuestion !== null) {
        $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');

        $('.questionnaire_form_main .form_loop').each(function () {
            if ($(this).data('question') == lastQuestion) {
                $(this).addClass('d-block').find('.number').html(lastNumber);
            }
        });
    }

    ensureHiddenField('which-country-do-you-live-in', 'Which country do you live in? *');
    setHiddenField('which-country-do-you-live-in', 'AU');
    ensureHiddenField('initial-indication', 'Initial Indication');
    setHiddenField('initial-indication', 'weight reduction management');
    getEntryByLink();
});


// ── Cookie Restore on Page Load ───────────────────────────────────────────────

$(document).ready(function () {
    var weightLossCookieValue = getCookie('weekly-maintenance');

    if (weightLossCookieValue !== null) {
        // Show continue button
        $('.continue_btn_content').removeClass('hidden');

        var weightLossObject     = JSON.parse(weightLossCookieValue);
        var weightLossObjectItem = weightLossObject.items || [];

        for (var i = 0; i < weightLossObjectItem.length; i++) {
            var currentObject = weightLossObjectItem[i];

            for (var key in currentObject) {
                if (!currentObject.hasOwnProperty(key)) continue;

                var cookieValue = currentObject[key];

                // Ensure hidden field exists
                var label = key; // fallback
                var questionText = $(".form_loop[data-question='" + key + "'] .dm-question").text();
                if (questionText) label = questionText;

                ensureHiddenField(key, label);
                setHiddenField(key, cookieValue);

                // Also restore visible inputs if present
                restoreVisibleInput(key, cookieValue);
            }
        }
    }
});

// Restore visible input/checkbox/select values from cookie
function restoreVisibleInput(handle, value) {
    // Text / number inputs and textareas
    var $input = $('.form_loop [name="' + handle + '"], .form_loop [id="' + handle + '"]');
    if ($input.is('input[type="text"], input[type="number"], textarea')) {
        $input.val(value);
        return;
    }

    // Checkboxes (single-select style)
    var $checkbox = $('.form_loop input[type="checkbox"][name="' + handle + '"][value="' + value + '"]');
    if ($checkbox.length) {
        $checkbox.prop('checked', true);
        // Trigger change so any show/hide logic fires
        $checkbox.trigger('change');
        return;
    }

    // Select dropdowns
    var $select = $('.form_loop select[name="' + handle + '"], .form_loop select[id="' + handle + '"]');
    if ($select.length) {
        $select.val(value);
        return;
    }
}



// ── Question 1: Patient Identification ───────────────────────────────────────

$('.form_loop[data-question="patient-identification"] .ok_btn_content .form_action_btn').click(function () {
    var $loop = $(this).parents('.form_loop');
    var $currentNumber = parseInt($loop.find('.number').html());

    $loop.find('.dm-error').remove();
    $loop.find('.input-error').removeClass('input-error');

    var hasError = false;

    // 1. Full Name
    var $nameInput = $loop.find('#full-name');
    var nameVal    = $.trim($nameInput.val());

    if (nameVal === '' || nameVal.length < 2) {
        $nameInput.addClass('input-error');
        $('<div class="dm-error">Full name is required (minimum 2 characters).</div>').insertAfter($nameInput);
        hasError = true;
    }

    // 2. Date of Birth
    var $dobFields = $loop.find('.ans-block').eq(1);
    var dobDD = $.trim($dobFields.find('.day input').val());
    var dobMM = $.trim($dobFields.find('.month input').val());
    var dobYY = $.trim($dobFields.find('.year input').val());

    if (!dobDD || !dobMM || !dobYY) {
        if (!dobDD) $dobFields.find('.day input').addClass('input-error');
        if (!dobMM) $dobFields.find('.month input').addClass('input-error');
        if (!dobYY) $dobFields.find('.year input').addClass('input-error');
        $('<div class="dm-error">Date of birth is required (DD/MM/YYYY).</div>').insertAfter($dobFields.find('.birth_date_field'));
        hasError = true;
    } else if (!isValidDate(dobDD, dobMM, dobYY)) {
        $dobFields.find('.day input, .month input, .year input').addClass('input-error');
        $('<div class="dm-error">Invalid date of birth. Please check DD / MM / YYYY.</div>').insertAfter($dobFields.find('.birth_date_field'));
        hasError = true;
    } else {
        var dobDate   = new Date(parseInt(dobYY), parseInt(dobMM) - 1, parseInt(dobDD));
        var today     = new Date();
        var ageInDays = (today - dobDate) / (1000 * 3600 * 24);

        if (dobDate > today) {
            $dobFields.find('.day input, .month input, .year input').addClass('input-error');
            $('<div class="dm-error">Date of birth cannot be in the future.</div>').insertAfter($dobFields.find('.birth_date_field'));
            hasError = true;
        } else if (ageInDays < 18 * 365.25) {
            $dobFields.find('.day input, .month input, .year input').addClass('input-error');
            $('<div class="dm-error">Patient must be at least 18 years old.</div>').insertAfter($dobFields.find('.birth_date_field'));
            hasError = true;
        }
    }

    if (hasError) { shakeEffect($loop); return; }

    // Save
    var formattedDOB = pad(dobDD) + '/' + pad(dobMM) + '/' + dobYY;

    var dataToSave = {
        'full-name'          : nameVal,
        'enter-your-date-of-birth'      : formattedDOB
    };

    $.each(dataToSave, function (handle, val) {
        const normalText = dehandleize(handle);
        ensureHiddenField(handle, normalText);
        setHiddenField(handle, val);
    });

    var $nextLoop = $loop.removeClass('d-block').addClass('d-none').next('.form_loop');
    $nextLoop.addClass('d-block').find('.number').html($currentNumber + 1);

    pushValueToCookieArray('weekly-maintenance', dataToSave, $nextLoop.data('question'), $currentNumber + 1);
    pushHistory($currentNumber + 1);
    CalculateP();
});


// ── Question 2: Baseline Information ─────────────────────────────────────────

$('.form_loop[data-question="baseline-information"] .ok_btn_content .form_action_btn').click(function () {
    var $loop = $(this).parents('.form_loop');
    var $currentNumber = parseInt($loop.find('.number').html());

    $loop.find('.dm-error').remove();
    $loop.find('.input-error').removeClass('input-error');

    var hasError = false;

    // 1. Starting Weight
    var $weightInput = $loop.find('#starting-weight');
    if ($(".form-selected-answer [data-handle='starting-weight']")) {
        if ($(".form-selected-answer [data-handle='starting-weight']").val()) {
            $weightInput.val($(".form-selected-answer [data-handle='starting-weight']").val());
        }   
    }
    var weightVal    = $.trim($weightInput.val());
    var weightNum    = parseFloat(weightVal);

    if (weightVal === '') {
        $weightInput.addClass('input-error');
        $('<div class="dm-error">Starting weight is required.</div>').insertAfter($weightInput);
        hasError = true;
    } else if (isNaN(weightNum) || weightNum < 20 || weightNum > 300) {
        $weightInput.addClass('input-error');
        $('<div class="dm-error">Please enter a valid weight between 20 and 300 kg.</div>').insertAfter($weightInput);
        hasError = true;
    }

    // 2. Starting BMI
    var $bmiInput = $loop.find('#starting-bmi');
    var bmiVal    = $.trim($bmiInput.val());
    var bmiNum    = parseFloat(bmiVal);

    if (bmiVal === '') {
        $bmiInput.addClass('input-error');
        $('<div class="dm-error">Starting BMI is required.</div>').insertAfter($bmiInput);
        hasError = true;
    } else if (isNaN(bmiNum) || bmiNum < 10 || bmiNum > 80) {
        $bmiInput.addClass('input-error');
        $('<div class="dm-error">Please enter a valid BMI between 10 and 80.</div>').insertAfter($bmiInput);
        hasError = true;
    }


    if (hasError) { shakeEffect($loop); return; }

    var dataToSave = {
        'starting-weight'    : weightVal,
        'starting-bmi'       : bmiVal,
        'initial-indication' : 'weight reduction management'
    };

    $.each(dataToSave, function (handle, val) {
        const normalText = dehandleize(handle);
        ensureHiddenField(handle, normalText);
        setHiddenField(handle, val);
    });

    var $nextLoop = $loop.removeClass('d-block').addClass('d-none').next('.form_loop');
    $nextLoop.addClass('d-block').find('.number').html($currentNumber + 1);

    pushValueToCookieArray('weekly-maintenance', dataToSave, $nextLoop.data('question'), $currentNumber + 1);
    pushHistory($currentNumber + 1);
    CalculateP();
});


// ── Question 3: Current Treatment ────────────────────────────────────────────

// Missed dose Yes/No toggle
$(document).on('change', '.form_loop[data-question="current-treatment"] .missed-dose-option', function () {
    var $loop = $(this).parents('.form_loop');
    $loop.find('.missed-dose-option').not(this).prop('checked', false);

    if ($(this).val() === 'Yes' && $(this).is(':checked')) {
        $loop.find('#missed-count-block').removeClass('d-none');
    } else {
        $loop.find('#missed-count-block').addClass('d-none');
        $loop.find('#missed-doses-count').val('').removeClass('input-error');
        $loop.find('#missed-count-block .dm-error').remove();
    }
});

$('.form_loop[data-question="current-treatment"] .ok_btn_content .form_action_btn').click(function () {
    var $loop = $(this).parents('.form_loop');
    var $currentNumber = parseInt($loop.find('.number').html());

    $loop.find('.dm-error').remove();
    $loop.find('.input-error').removeClass('input-error');

    var hasError = false;

    // 1. Current Medication
    var $medInput = $loop.find('#current-medication');
    var medVal    = $.trim($medInput.val());
    if (medVal === '') {
        $medInput.addClass('input-error');
        $('<div class="dm-error">Current medication is required.</div>').insertAfter($medInput);
        hasError = true;
    }

    // 2. Current Dose
    var $doseInput = $loop.find('#current-dose');
    var doseVal    = $.trim($doseInput.val());
    if (doseVal === '') {
        $doseInput.addClass('input-error');
        $('<div class="dm-error">Current dose is required.</div>').insertAfter($doseInput);
        hasError = true;
    }

    // 3. Duration on Dose
    var $durationInput = $loop.find('#duration-on-dose');
    var durationVal    = $.trim($durationInput.val());
    if (durationVal === '') {
        $durationInput.addClass('input-error');
        $('<div class="dm-error">Duration on this dose is required.</div>').insertAfter($durationInput);
        hasError = true;
    }

    // 4. Missed Doses Yes/No
    var $selectedOption = $loop.find('.missed-dose-option:checked');
    if ($selectedOption.length === 0) {
        $('<div class="dm-error">Please select Yes or No for missed doses.</div>').insertAfter($loop.find('#missed-doses-block .maintaining_option').last());
        shakeEffect($loop.find('#missed-doses-block'));
        hasError = true;
    }

    var missedVal      = $selectedOption.val();
    var missedCountVal = '';

    // 5. Missed Count (if Yes)
    if (missedVal === 'Yes') {
        var $countInput  = $loop.find('#missed-doses-count');
        missedCountVal   = $.trim($countInput.val());
        var countNum     = parseInt(missedCountVal);

        if (missedCountVal === '') {
            $countInput.addClass('input-error');
            $('<div class="dm-error">Please enter number of missed doses.</div>').insertAfter($countInput);
            hasError = true;
        } else if (isNaN(countNum) || countNum < 1 || countNum > 28) {
            $countInput.addClass('input-error');
            $('<div class="dm-error">Please enter a valid number between 1 and 28.</div>').insertAfter($countInput);
            hasError = true;
        }
    }

    if (hasError) { shakeEffect($loop); return; }

    var dataToSave = {
        'current-medication' : medVal,
        'current-dose'       : doseVal,
        'duration-on-this-dose'   : durationVal,
        'any-missed-doses-in-the-last-4-weeks-?'       : missedVal,
        'how-many-missed-doses-?' : missedCountVal
    };

    $.each(dataToSave, function (handle, val) {
        const normalText = dehandleize(handle);
        ensureHiddenField(handle, normalText);
        setHiddenField(handle, val);
    });

    var $nextLoop = $loop.removeClass('d-block').addClass('d-none').next('.form_loop');
    $nextLoop.addClass('d-block').find('.number').html($currentNumber + 1);

    pushValueToCookieArray('weekly-maintenance', dataToSave, $nextLoop.data('question'), $currentNumber + 1);
    pushHistory($currentNumber + 1);
    CalculateP();
});


// ── Question 4: Weight & Progress ────────────────────────────────────────────

// Single-select checkbox behaviour
$(document).on('change', '.form_loop[data-question="weight-amp-progress"] .single-select-option', function () {
    var groupName = $(this).attr('name');
    var $loop     = $(this).parents('.form_loop');

    if ($(this).is(':checked')) {
        $loop.find('input[name="' + groupName + '"]').not(this).prop('checked', false);
        $(this).closest('.ans-block').find('.dm-error').remove();
    }
});

$('.form_loop[data-question="weight-amp-progress"] .ok_btn_content .form_action_btn').click(function () {
    var $loop = $(this).parents('.form_loop');
    var $currentNumber = parseInt($loop.find('.number').html());

    $loop.find('.dm-error').remove();
    $loop.find('.input-error').removeClass('input-error');

    var hasError = false;
    var answers  = {};

    // 1. Required text inputs
    $loop.find('.input-field-req').each(function () {
        var val       = $.trim($(this).val());
        var inputName = $(this).attr('name') || $(this).attr('id');

        if (val === '') {
            $(this).addClass('input-error');
            $('<div class="dm-error">This field is required.</div>').insertAfter($(this));
            hasError = true;
        } else {
            answers[inputName] = val;
        }
    });

    // 2. Required radio/checkbox groups
    $loop.find('.radio-group-req').each(function () {
        var $checkedOption = $(this).find('.single-select-option:checked');
        var groupName      = $(this).find('.single-select-option').first().attr('name');

        if ($checkedOption.length === 0) {
            $('<div class="dm-error">Please select an option.</div>').insertAfter($(this).find('.maintaining_option').last());
            shakeEffect($(this));
            hasError = true;
        } else {
            answers[groupName] = $checkedOption.val();
        }
    });

    // 3. Optional fields
    var otherSE  = $.trim($loop.find('#other-side-effects').val());
    var concerns = $.trim($loop.find('#concerns').val());
    if (otherSE)  answers['any-other-side-effects'] = otherSE;
    if (concerns) answers['any-concerns-?']            = concerns;

    if (hasError) { shakeEffect($loop); return; }

    // Save all answers
    $.each(answers, function (handle, val) {
        const normalText = dehandleize(handle);
        ensureHiddenField(handle, normalText);
        setHiddenField(handle, val);
    });

    // Save to cookie (mark as finished)
    pushValueToCookieArray('weekly-maintenance', answers, 'finished', $currentNumber + 1);

    // Submit form
    $('#callback-form').submit();

    pushHistory($currentNumber + 1);
    CalculateP();
});





var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    ga('send', 'event', {
        eventCategory: 'weekly-maintenance',
        eventAction: 'Submit',
        eventLabel: 'Weekly Maintenance form',
        eventValue: 1
    });

  $('.form-selected-answer').append(`<input type="hidden" name="random_string" value="${window.user_link}">`);
  $Form.find("input[type='hidden']").each(function() {
    var get_data_handle = $(this).attr('data-handle');
      if($(this).val() == ""){
        $(this).remove();
      }
  })


  setTimeout(() => {
    $.ajax({
        url: $Form.attr('action'),
        cache: false,
        type: 'post',
        data: $Form.serialize(),
        success: function(itemData) {
            var data = JSON.parse(itemData);

            var cookieToDelete = 'weekly-maintenance';
            deleteCookie(cookieToDelete);
            deleteCookie("weekly-maintenance_lastQuestionafter");

            setTimeout(function() {
                $('.loading-wrapper').hide();
                var $mainWrapper = $('.questionnaire_form_main');
                // Hide form wrapper
                $mainWrapper.find('.dm-form-wrapper').addClass('hide');
                $mainWrapper.find('.progress_bar').addClass('hide');
                // Success HTML (customize if needed)
                var successHTML = `
                <div class="form-success-message">
                    <h2>Thank You</h2>
                    <p>A Doctor will call you within the next 24 hours to discuss your maintenance plan. If you wish to discuss it sooner, please contact us to book a call.</p>
                    <a href="/" class="btn">Go to Home</a>
                </div>
                `;

                // Append success message
                $mainWrapper.append(successHTML);
            }, 1000);
        },
        error: function() {
        }
    });
  },500);
});



function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0;
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / $('.form-selected-answer input').length * 100);
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function fillvalue(question) {
    if ($('.form-selected-answer [data-handle=' + question + ']').val() == '') {
        $('.form-selected-answer [data-handle=' + question + ']').val('No response');
    }
}

function pushHistory(number) {
    const url = new URL(window.location.href);

    url.searchParams.set('question', number);

    window.history.pushState("", "", url);

    ga('send', {
        hitType: 'pageview',
        page: url.pathname + url.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}
